<template lang="pug">
  .validations
    .result-icon(:class="css" :id="css_id")
      icon-mdi(:icon="icon")

    b-tooltip(:target="css_id" triggers="hover")  {{tooltip_text}}

</template>

<script>
import { mdiBadgeAccountAlert } from '@mdi/js';
import { mdiCheck } from '@mdi/js';
import IconMdi from "../icons/IconMdi";
export default {
name: "CustomerValidations",
  components: {IconMdi},
  props:{
    id: Number,
    errors: Array,
  },
  data(){
    return {
      alert_icon: mdiBadgeAccountAlert,
      ok_icon: mdiCheck
    }
  },
  computed:{
    css_id(){
      return `customer-${this.id}-validations`
    },
    is_valid(){
      return this.errors ? this.errors.length === 0 : undefined;
    },
    icon(){
      return this.is_valid ? this.ok_icon : this.alert_icon;
    },
    css(){
      return this.is_valid ? 'success' : 'danger';
    },
    tooltip_text(){
      if (this.is_valid) {
        return 'Необходимые поля заполнены'
      } else {
        return `Не заполнены поля: ${this.errors.join(', ')}`
      }
    }
  }

}
</script>

<style scoped>
 .validations .result-icon {
   width: 30px;
   height: 30px;
 }
 .validations .result-icon.danger{
   color: #c4000c;
 }
 .validations .result-icon.success{
   color: #679500;
 }
</style>